import { get, post, put } from '../../helpers/api';

/**
 * The lane polyline editor's endpoints. Separate from LaneMapApi because that
 * module is the read-only map's data source and this one writes.
 *
 * `fetchPolyline` hits `/polyline`, NOT `/lanes`. `/lanes` returns geometry
 * simplified for the requested zoom; saving what it returns would silently
 * discard vertices across the whole lane, including stretches nobody edited.
 * Never swap this to reuse the lanes query for convenience.
 */
const fetchPolyline = async (laneId) => {
  const { data } = await get(`/admin/lane-map/lanes/${laneId}/polyline`);
  return data;
};

/** Re-route one section along real roads between two anchors. */
const snapSection = async (laneId, { anchorStart, anchorEnd, waypoints }) => {
  const { data } = await post(`/admin/lane-map/lanes/${laneId}/polyline/snap`, {
    anchorStart,
    anchorEnd,
    waypoints,
  });
  return data;
};

/** What committing this candidate would do. Writes nothing. */
const previewPolyline = async (laneId, candidateGeoJson) => {
  const { data } = await post(`/admin/lane-map/lanes/${laneId}/polyline/preview`, {
    candidateGeoJson,
  });
  return data;
};

/** Commit. `expectedUpdatedAt` must be the value from `fetchPolyline`. */
const commitPolyline = async (laneId, body) => {
  const { data } = await put(`/admin/lane-map/lanes/${laneId}/polyline`, body);
  return data;
};

/** Past edits, newest first, each carrying the geometry it replaced. */
const fetchHistory = async (laneId) => {
  const { data } = await get(`/admin/lane-map/lanes/${laneId}/polyline/history`);
  return data;
};

export default {
  fetchPolyline,
  snapSection,
  previewPolyline,
  commitPolyline,
  fetchHistory,
};
